import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/shared/services/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ordersService {

  constructor(private api : ApiService) { }

  getOrders(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}lms-service/job/getJobs?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
} 
  getDraftJobs(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}lms-service/job/getDraftJobs?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
} 

addOrUpdate(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'lms-service/job/addOrUpdate')
  return this.api.post(url,formData);
}
draftAddOrUpdate(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'lms-service/job/draftAddOrUpdate')
  return this.api.post(url,formData);
}
bulkAddOrUpdate(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'ems-service/budget/bulkAddOrUpdate')
  return this.api.post(url,formData);
}
getRoleMappingList(){
  const url = `${environment.New_BASE_DOMAIN}auth-service/role/getRoleMappingList`;
  return this.api.get(url);
} 

getBudgetTransactions(formData:any,pageNumber:any,pageSize:any){
  const url = `${environment.New_BASE_DOMAIN}ems-service/budget/getBudgetTransactions?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=updatedAt&direction=DESC`;
  return this.api.post(url,formData);
}
getLineItemTransactions(formData:any,pageNumber:any,pageSize:any){
  const url = `${environment.New_BASE_DOMAIN}lms-service/job/getLineItemTransactions?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=updatedAt&direction=ASC`;
  return this.api.post(url,formData);
}

updateLineItems(payload:any){
  const url = (environment.New_BASE_DOMAIN + 'lms-service/job/addOrUpdate')
  return this.api.post(url,payload);
}
getAssociateList(payload:any,pageNumber:any,pageSize:any){
  const url = `${environment.New_BASE_DOMAIN}lms-service/user/getUsers?pageNumber=${pageNumber}&pageSize=${pageSize}&direction=ASC`;
  return this.api.post(url,payload);
}

}
